import React, { useState, useEffect } from "react";
import { injectModels } from "../redux/injectModels";
import { useParams, Link } from "react-router-dom";
import { routes } from "../constants/routes";

import { AuthService } from "../services";
import { handleConsoleError } from "../utils/common-methods";

function UserEmailVerification(props) {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {

      const emailConfirmation= async ()=>{
  var data = { Token: token };
  try {
        const response = await AuthService.confirmEmail(data);
        console.log(response);
          if (response?.isSuccess) {
            setData(response?.data??data);
      
          }
          else{
             setError(response?.message||"Something went wrong");
          }
      } catch (err) {
          const message= handleConsoleError(err);
       setError(err?.message || message);
      }
    }

    emailConfirmation();
   
  }, []); // Empty array means this effect runs once when the component mounts

  return (
    <React.Fragment>
      <section className="loginswallow-dashboard">
        <div
          style={{
            textAlign: "center",
            marginTop: "100px",
            minHeight: "300px",
          }}
        >
          <h1>Account Verification</h1>
          {data && (
            <div>
              <p>Your account email has been confirmed successfully</p>
              <Link to={routes.DEFAULT}>Go to Home</Link>
            </div>
          )}
          {error && (
            <div>
              <p>{error} Please contact to admin</p>
            </div>
          )}
        </div>
      </section>
    </React.Fragment>
  );
}
export default injectModels(["admin", "application"])(UserEmailVerification);
